import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { AddGroupComponent } from "../../mnt-products/add-group/add-group.component";
import { CommonService } from "../../_services/common.service";

// import { FlashMessagesService } from "angular2-flash-messages";


import {
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  FormControl
} from "@angular/forms";

export interface DialogData {
  sizeList: Array<any>,
  colorList: any,
  colorIdx: string
}

@Component({
  selector: 'app-add-color-row',
  templateUrl: './add-color-row.component.html',
  styleUrls: ['./add-color-row.component.css']
})
export class AddColorRowComponent implements OnInit {
  addColorRowForm: FormGroup;
  private result: any = {};
  selectedColors: Array<any> = [];
  errormsg: string;
  groupColors: any = {};
  public title = "Add Color Row";

  constructor(private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<AddColorRowComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private dialog: MatDialog,
    private CommonService: CommonService

  ) { }

  ngOnInit() {
    this.addColorRowForm = this.formBuilder.group({
      colorId: [null, Validators.required]
      //sizeId: [null, Validators.required]
    });
    if (this.data.colorIdx != '') {
      this.title = "Change Color";
    }
  }

  onNoClick(): void {
    this.dialogRef.close(this.result);
  }

  isFieldValid(field: string) {
    return (
      !this.addColorRowForm.get(field).valid &&
      this.addColorRowForm.get(field).touched
    );
  }

  AddColor(postData) {
    this.errormsg = "";
    if (this.selectedColors.length == 0) {
      this.errormsg = "Please select color for add color row";
      // this._flashMessagesService.show("Please select color for add color row", {
      //   cssClass: "alert-danger",
      //   timeout: 5000
      // });     
      return;
    }
    this.result = {
      //sizeData:postData.sizeId=='All'?this.data.sizeList:postData.sizeId,
      colorData: this.selectedColors
    };
    this.dialogRef.close(this.result);

  }

  checkSelectedColor(colorId) {
    return this.selectedColors.findIndex(x => x.primary_color_id == colorId) >= 0 ? true : false;
  }

  selectedColor(color) {
    if (this.data.colorIdx != '' && this.selectedColors.length > 0) {
      this.errormsg = "Please select only one color on update";
      return;
    }
    let colorIndex = this.selectedColors.findIndex(x => x.primary_color_id == color.primary_color_id);
    if (colorIndex >= 0) {
      this.selectedColors.splice(colorIndex);
    }
    else {
      this.selectedColors.push(color);
    }
  }

  trackByFn(index: any, item: any) {
    return index;
  }

  openUpdateColorDialog() {
    this.errormsg='';
    if (this.groupColors.color_group_id) {
      const dialogRef = this.dialog.open(AddGroupComponent, {
        width: "250px",
        data: {
          group_id: this.groupColors.color_group_id,
          name: this.groupColors.name
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.getColorList();
        }
      });
    }
    else {
      this.errormsg = "please select color group";
    }
  }

  onSizeChange(event) {
    //console.log('grp name',grp);
    if (event.isUserInput) {
      if (event.source.selected) {
        let st = event.source.value;
        this.groupColors = st;
      }

    }
  }

  getColorList = function () {
    this.CommonService.apiService(
      "GET",
      "colors/" + this.groupColors.color_group_id
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          if (response.data) {
            //this.colorList = response.data;
            //this.colorName=[];
            //this.colorImage=[];
            this.groupColors.colors = [];
            response.data.forEach((element, index) => {
              this.groupColors.colors.push({
                primary_color_id: element.color_id,
                name: element.name,
                image: element.image
              });
            });

          }
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  getFirstColor(code: string): string {
    return code ? code.split(',')[0] : 'ffffff';
  }


}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-products/add-color-row/add-color-row.component.ts